import { Link } from "react-router-dom";

const heroImg =
  "https://readdy.ai/api/search-image?query=Panoramic%20Chinese%20ink%20wash%20painting%20of%20towering%20misty%20mountain%20peaks%20with%20a%20small%20ancient%20sect%20village%20nestled%20among%20clouds%20and%20pines%2C%20warm%20golden%20cream%20paper%20tone%20with%20soft%20cinnabar%20red%20and%20gold%20accents%2C%20hand%20drawn%20brush%20strokes%2C%20dreamy%20morning%20light%2C%20serene%20traditional%20xianxia%20cultivation%20atmosphere%2C%20minimal%20elegant%20composition&width=1600&height=900&seq=hero-xianxia-sxs&orientation=landscape";

const stats = [
  { value: "50+", label: "深度剧情解析" },
  { value: "12万字", label: "体系与脉络梳理" },
  { value: "3万+", label: "同好一起追更" },
  { value: "800+", label: "热议讨论主题" },
];

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="h-[480px] w-full md:h-[600px]">
        <img
          src={heroImg}
          alt="师兄啊师兄宗门篇水墨仙侠群山背景图"
          title="师兄啊师兄宗门篇 · 修仙群山水墨背景"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/40 via-foreground-950/30 to-foreground-950/55"></div>

      <div className="absolute inset-0 flex w-full items-center justify-center px-4 md:px-6">
        <div className="flex w-full flex-col items-center text-center">
          <p className="flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs tracking-widest text-background-100 backdrop-blur">
            <i className="ri-sparkling-2-line text-accent-300"></i>
            宗门篇 · 修炼境界 · 主线剧情全梳理
          </p>
          <h1 className="mt-6 font-ink text-4xl leading-tight text-background-50 md:text-6xl">
            师兄啊师兄
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200/90 md:text-base">
            从宗门篇发展脉络到修炼境界体系，从主线伏笔到角色成长，
            这里把《师兄啊师兄》的剧情讲透。同好陪你一起聊透剧情，追更不迷路。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/section/zongmen"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-community-line text-base"></i>
              进入宗门篇剧情
            </Link>
            <Link
              to="/section/jingjie"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <i className="ri-fire-line text-base"></i>
              查看修炼境界
            </Link>
          </div>

          <dl className="mt-10 grid w-full max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-xl border border-background-50/20 bg-background-950/20 px-4 py-4 backdrop-blur"
              >
                <dt className="order-2 mt-1 block text-xs text-background-200/80">{s.label}</dt>
                <dd className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}